import { Column, Conditional, Else, Heading, If, makeClassName, Modal, ModalProps, Row } from "@hex-insights/core";
import { ParentPortalReportCardsQuery } from "../../../../Utilities";
import { AcademicTermFormat, StudentFormat } from "../../../Format";
import { FileAttachmentView } from "../../MediaAttachment";
import { StudentIcon } from "../../Student";
import styles from "./styles.module.css";

export type ReportCardsGuardianModalProps = {
	isLoading?: boolean;
	data: ParentPortalReportCardsQuery | undefined;
} & Pick<ModalProps, "ifRef" | "onClose" | "className" | "style">;

export function ReportCardsGuardianModal({
	isLoading = false,
	data,
	ifRef,
	onClose,
	className,
	style,
}: ReportCardsGuardianModalProps) {
	return (
		<Modal ifRef={ifRef} onClose={onClose} className={makeClassName(styles["modal"], className)} style={style}>
			<Modal.Header className={styles["modal__header"]}>
				<Heading.H2 noMargin>2023-2024 Report Cards</Heading.H2>
			</Modal.Header>
			<Modal.Body>
				<Conditional>
					<If condition={isLoading && !data}>
						<span>Loading...</span>
					</If>
					<Else>
						<Column justify="spaced-start" verticalSpacing="1rem">
							{data?.reportCardConnection.edges.map((e) => (
								<ReportCardItem key={e.node.id} reportCard={e.node} />
							))}
						</Column>
					</Else>
				</Conditional>
			</Modal.Body>
		</Modal>
	);
}

type ReportCardItemProps = {
	reportCard: ParentPortalReportCardsQuery["reportCardConnection"]["edges"][0]["node"];
};

function ReportCardItem({ reportCard }: ReportCardItemProps) {
	const fileName =
		(StudentFormat.name(reportCard.student) + " " + AcademicTermFormat.name(reportCard.academicTerm))
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "")
			.replace(/\s/g, "-") + ".pdf";

	return (
		<Column justify="spaced-start" verticalSpacing="0.5rem" className={styles["report-card-item"]}>
			<Row justify="spaced-start" align="center" horizontalSpacing="0.5rem">
				<StudentIcon student={reportCard.student} size={32} />
				<span className={styles["report-card-item__student-name"]}>{StudentFormat.name(reportCard.student)}</span>
			</Row>

			<FileAttachmentView
				title={fileName}
				fileURL={reportCard.fileURL}
				fileContentType={reportCard.fileContentType}
				downloadLabel="full"
			/>
		</Column>
	);
}
